/* unplugin-vue-components disabled */import { render } from "./companyIntro.vue?vue&type=template&id=c774ca78"
import script from "./companyIntro.vue?vue&type=script&lang=js"
export * from "./companyIntro.vue?vue&type=script&lang=js"

import "./companyIntro.vue?vue&type=style&index=0&id=c774ca78&lang=css"

import exportComponent from "F:\\vue2.0+ vant\\2024年项目集合\\元羿官网项目集合\\元羿英文版本\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__